<template>
	<el-dialog title="新增巡检路线" :visible.sync="dialogFormVisible" width="800px">
		
		<el-form :model="formNew" ref="formNew" label-width="150px" class="demo-form-inline" size="medium">
			<el-form-item label="所属组织" prop="parent">
            	<el-input v-model="formNew.parent" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="巡检路线名称" prop="patrolroad_name">
            	<el-input v-model="formNew.patrolroad_name" autocomplete="off"></el-input>
          	</el-form-item>
          	<el-form-item label="巡检账号" prop="patrolroad_accounts">
            	<div id="box_accounts">
            		<div>#账号1 #账号2 #账号3 #账号4 #账号5</div>
            		<el-button size="mini" icon="el-icon-edit" class="account-box-edit-btn" round>编辑</el-button>
            	</div>
          	</el-form-item>
          	<el-form-item label="周期选择" prop="cycle_choose">
            	<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
			    <div style="margin: 15px 0;"></div>
			    <el-checkbox-group v-model="checkedWeeks" @change="handleCheckedWeeksChange">
			    	<el-checkbox v-for="week in weeks" :label="week" :key="week">{{week}}</el-checkbox>
			  	</el-checkbox-group>
          	</el-form-item>
          	<el-form-item label="开始-结束时间" prop="time">
            	<el-time-select
				    placeholder="起始时间"
				    v-model="formNew.startTime"
				    :picker-options="{
				      start: '08:30',
				      step: '00:15',
				      end: '18:30'
				    }">
				  </el-time-select>
				  &nbsp;&nbsp;
				  <el-time-select
				    placeholder="结束时间"
				    v-model="formNew.endTime"
				    :picker-options="{
				      start: '08:30',
				      step: '00:15',
				      end: '18:30',
				      minTime: formNew.startTime
				    }">
				  </el-time-select>
          	</el-form-item>
          	<el-form-item label="巡检项名称" prop="road_line">
            	<el-transfer v-model="transfer.value" :titles="['待选巡检项', '已选巡检项']" :data="transfer.data"></el-transfer>
          	</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
          	<el-button @click="dialogFormVisible = false">取 消</el-button>
          	<el-button type="primary" @click="saveData()">保 存</el-button>
        </div>
	</el-dialog>
</template>

<script>
import Api from '../../api/index'

const weekOptions = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];

export default {
  name: "PatrolRoadForm",
  data() {
  	const generateData = _ => {
        const data = [];
        const cities = ['541-东直门', '542-水池', '543-小花坛', '545-大象', '546-新草坪', '547-大榕树', '548-洗手间', '549-观景鱼塘', '550-雷锋塔', '551-情人桥', '552-沙地'];
        const pinyin = ['shanghai', 'beijing', 'guangzhou', 'shenzhen', 'nanjing', 'xian', 'chengdu', 'yutang', 'g50', 'g60', 'g70'];
        cities.forEach((city, index) => {
          data.push({
            label: city,
            key: index,
            pinyin: pinyin[index]
          });
        });
        return data;
    };
    return {
        dialogFormVisible: false,
        parent_id: 0,
        checkAll: false,
        weeks: weekOptions,
        checkedWeeks: ['周一', '周二', '周三', '周四', '周五'],
        isIndeterminate: true,
        formNew: {
        	hold_id: 0,
        	parent: "",
        	patrolroad_name: "",
        	startTime: '',
        	endTime: ''
        },
        transfer: {
        	data: generateData(),
        	value: [1, 4]
        }
    };
  },
  methods: {
  	handleCheckAllChange(val) {
	    this.checkedWeeks = val ? weekOptions : [];
	    this.isIndeterminate = false;
    },
    handleCheckedWeeksChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.weeks.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.weeks.length;
    },
    show: function(id, parent_id) {
        this.dialogFormVisible = true;
        if(id > 0) {

        } else {
        	this.parent_id = parent_id;
        	Api.LoadParentBase({ id: this.parent_id }).then(res => {
	            if(!res && res.code !== 200)
	              return;

	            if(res.data) {
	              this.formNew.hold_id = res.data.hold_id;
	              this.formNew.parent = res.data.hold_name;
	            }
            });
        }
    },
    saveData: function() {

    }
  }
}
</script>

<style>
	#box_accounts {
		padding-top: 5px;
		padding-left: 10px;
		border-color: #dddddd;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}
	.account-box-edit-btn {
		margin-bottom: 10px;
	}
</style>